import React from 'react';
import logo from './logo.svg';
import './grid.css';
import './main.scss';
import './responsive.scss';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
  useRouteMatch
} from "react-router-dom";

import Home from './templates/home'
import About from './templates/about'
import Project from './templates/project'
import Projects from './templates/projects'
import Header from './sections/header'
import ProjectLoop from './sections/project-loop'
import NoMatch from './sections/no-match'

class App extends React.Component {
  render(){
  return (
    <main className="App">
      <Router>
        <Header />
        <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route exact path="/projects">
              <Projects />
            </Route>
            <Route path="/projects/:id">
              <ProjectContainer />
            </Route>
            {/* <Route path="/about">
              <About />
            </Route> */}
            <Route path="*">
            <NoMatch />
            </Route>
        </Switch>
      </Router>
    </main>
  );
  }
}

function ProjectContainer(){
  let { id } = useParams();
  return (
    <Project id={id} />
  )
}

export default App;
